import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';

const FIELD_LABELS = {
  name: 'Nom',
  price: 'Prix',
  description: 'Description',
  hidden: 'Visibilité',
  arUrl: 'URL AR',
  category: 'Catégorie',
  image: 'Image',
};

const SyncValidationToast = ({ validations, onDismiss }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (validations?.length > 0) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        setTimeout(() => onDismiss?.(), 300);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [validations]);

  if (!validations?.length) return null;

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 w-80 bg-card border border-border rounded-xl shadow-warm-2xl transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-border bg-primary/5 rounded-t-xl">
        <div className="flex items-center gap-2">
          <Icon name="CheckCircle2" size={16} color="var(--color-success)" />
          <span className="text-sm font-semibold text-foreground">Synchronisation confirmée</span>
        </div>
        <button
          onClick={() => { setVisible(false); setTimeout(() => onDismiss?.(), 300); }}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <Icon name="X" size={14} />
        </button>
      </div>

      {/* Validation rows */}
      <div className="px-4 py-3 space-y-2 max-h-60 overflow-y-auto">
        {validations?.map((v, i) => (
          <div key={i} className="flex items-start gap-2">
            <div className={`mt-0.5 flex-shrink-0 w-4 h-4 rounded-full flex items-center justify-center ${
              v?.synced ? 'bg-green-100' : 'bg-red-100'
            }`}>
              <Icon
                name={v?.synced ? 'Check' : 'X'}
                size={10}
                color={v?.synced ? '#16a34a' : '#dc2626'}
              />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium text-foreground truncate">
                {v?.dishName}
              </p>
              <p className="text-xs text-muted-foreground">
                <span className="font-medium">{FIELD_LABELS?.[v?.field] || v?.field}</span>
                {' '}→{' '}
                <span className={v?.synced ? 'text-green-600' : 'text-red-500'}>
                  {v?.synced ? 'Synchronisé' : 'Échec'}
                </span>
              </p>
              {v?.targets?.length > 0 && (
                <div className="flex gap-1 mt-0.5 flex-wrap">
                  {v?.targets?.map((target, ti) => (
                    <span
                      key={ti}
                      className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-primary/10 text-primary text-[10px] rounded-full font-medium"
                    >
                      <Icon name="ArrowRight" size={8} />
                      {target}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="px-4 py-2 border-t border-border bg-muted/30 rounded-b-xl">
        <p className="text-[10px] text-muted-foreground text-center">
          Menu client &amp; tableau de bord mis à jour
        </p>
      </div>
    </div>
  );
};

export default SyncValidationToast;
